// The columns button in the head of the actions column (see
// GridHiddenColumnsButton): it takes the head text colour, and keeps the
// head row at its height.
export const hiddenColumnsButtonSx = {
    'color': 'inherit',
    'p': 0.5,
    'my': -0.5,
    '& .MuiBadge-badge': {
        height: 16,
        minWidth: 16,
        px: 0.5,
        fontSize: 11
    },
    '& svg': {
        fontSize: 18
    }
};

export const hiddenColumnsPaperSx = (theme) => ({
    minWidth: 260,
    maxWidth: 360,
    maxHeight: 360,
    py: 0.5,
    borderRadius: `${theme.shape.popover}px`
});

// A section title in the menu (a list subheader, skipped by the keyboard).
export const hiddenColumnsTitleSx = {
    px: 2,
    pt: 1,
    pb: 0.5,
    typography: 'overline',
    lineHeight: 1.5,
    color: 'text.secondary',
    bgcolor: 'transparent'
};

export const hiddenColumnsItemSx = {
    'gap': 2,
    'justifyContent': 'space-between',
    'typography': 'body2',
    '& > span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
};

export const hiddenColumnsShowSx = {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    flexShrink: 0,
    color: 'primary.main',
    typography: 'caption',
    fontWeight: 600
};

// A setting in the menu: icon, label, and a check on the current one.
export const hiddenColumnsOptionSx = {
    'gap': 1,
    'typography': 'body2',
    'whiteSpace': 'normal',
    '& > span': {
        flexGrow: 1
    },
    '& > svg': {
        color: 'text.secondary'
    },
    '& > svg:last-of-type:not(:first-of-type)': {
        color: 'primary.main'
    }
};
